import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Moment from 'moment';
import { List } from 'immutable';

import * as actions from '../actions';
import * as selectors from '../selectors';
import SessionEdit from './SessionEdit';
import clients from '../../clients';
import locations from '../../locations';

class SessionEditContainer extends Component {
  componentDidMount() {
    this.props.fetchClientsIfNeeded();
    this.props.fetchLocationsIfNeeded();
    this.props.fetchSessionsIfNeeded();
    this.props.setActive(this.props.match.params.id);
  }

  handleSubmit = values => {
    const { history, submitSessionEdit } = this.props;

    // Generate Date object from date and time values & clean up
    Moment.locale('en');
    values = values.set(
      'startsAt',
      Moment(
        Moment(values.get('date')).format('YYYY-MM-DD') +
          ' ' +
          values.get('time')
      ).toISOString()
    );
    values = values.delete('date').delete('time');

    // Duration string/number conversion - required because redux-form Field radio values are strings
    values = values.set('duration', parseInt(values.get('duration'), 10));

    return submitSessionEdit(this.props.match.params.id, values, history);
  };

  render() {
    const { ui } = this.props;
    if (ui.isLoading === true) {
      return null;
    }

    let props = {
      onSubmit: this.handleSubmit,
      allClients: this.props.allClients.toList(),
      allLocations: this.props.allLocations.toList(),
      isLoading: ui.get('isLoading'),
      isError: ui.get('isError'),
      errorMessage: ui.get('errorMessage')
    };
    const { session } = this.props;

    if (typeof this.props.match.params.id !== 'undefined') {
      if (typeof session === 'undefined') {
        // Still loading
        return null;
      }
      const startsAt = new Date(session.get('startsAt'));
      props.initialValues = {
        ...session,
        locationId: session.get('locationId'),
        clientIds: session.get('clientIds'),
        duration: session.get('duration').toString(),
        recurs: session.get('recurring').get('recurs'),
        date: startsAt,
        time: `${startsAt.getHours()}:${startsAt.getMinutes()}`
      };
    } else {
      const clientIds =
        typeof this.props.match.params.clientId === 'undefined'
          ? List()
          : List.of(this.props.match.params.clientId);
      props.initialValues = {
        date: new Date(),
        time: '16:00',
        duration: '30',
        recurs: false,
        clientIds
      };
    }

    return <SessionEdit {...props} />;
  }
}

const mapStateToProps = createStructuredSelector({
  session: selectors.getActive,
  ui: selectors.getUI,
  allClients: clients.selectors.getEntities,
  allLocations: locations.selectors.getEntities
});

export default connect(mapStateToProps, {
  ...actions,
  fetchClientsIfNeeded: clients.actions.fetchClientsIfNeeded,
  fetchLocationsIfNeeded: locations.actions.fetchLocationsIfNeeded
})(SessionEditContainer);



// WEBPACK FOOTER //
// ./src/modules/sessions/components/SessionEditContainer.js